import { Modal, Box, Typography, Button } from '@mui/material';

export function SSOModal({ showPopupBlockerModal, setShowPopupBlockerModal }) {
  return (
    <Modal
      open={showPopupBlockerModal}
      onClose={() => setShowPopupBlockerModal(false)}
      aria-labelledby="popup-blocker-modal-title"
      aria-describedby="popup-blocker-modal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 500,
          bgcolor: 'background.paper',
          border: 'none',
          outline: 'none',
          p: 4,
          borderRadius: 5,
        }}
      >
        <Typography id="popup-blocker-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
          Popup Blocker Detected
        </Typography>
        <Typography id="popup-blocker-modal-description" sx={{ mb: 2 }}>
          It looks like your pop up blocker is enabled. Please disable it for this website and restart the page. 
        </Typography>
        <Typography variant="body2" sx={{ mb: 1 }}>
          Learn how to disable pop-up blockers for your browser:
        </Typography>
        <Box sx={{ mb: 3, pl: 2 }}>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            • <a href="https://support.google.com/chrome/answer/95472?hl=en-GB&co=GENIE.Platform%3DDesktop" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Google Chrome
            </a>
          </Typography>
          <Typography variant="body2" sx={{ mb: 0.5 }}>
            • <a href="https://support.mozilla.org/en-US/kb/pop-blocker-settings-exceptions-troubleshooting" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Mozilla Firefox
            </a>
          </Typography>
          <Typography variant="body2">
            • <a href="https://support.microsoft.com/en-gb/microsoft-edge/block-pop-ups-in-microsoft-edge-1d8ba4f8-f385-9a0b-e944-aa47339b6bb5" target="_blank" rel="noopener noreferrer" style={{ color: '#1976d2', textDecoration: 'none' }}>
              Microsoft Edge
            </a>
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button variant="contained" onClick={() => setShowPopupBlockerModal(false)}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
